var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParameterFlowManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-\u5E94\u7528\u4E2D\u5FC3\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u4F18\\u5316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-416.5, -191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-\\u5E94\\u7528\\u4E2D\\u5FC3\\u5907\\u4EFD",
    transform: "translate(415, 190)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 1.5,
    y: 1,
    className: "st0",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62_1_",
    className: "st1",
    d: "M16,2v10H3V2H16z M15,3H4v8h11V3z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_2_",
    x: 9,
    y: 12,
    className: "st2",
    width: 1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-5",
    x: 5.5,
    y: 15,
    className: "st2",
    width: 8,
    height: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParameterFlowManagement);
export default __webpack_public_path__ + "static/media/parameter-flow-management.eea91b056a06b56b9794048e99cdcd4b.svg";
export { ForwardRef as ReactComponent };